import { Button, DatePicker, Form, Input, InputNumber, Select, Spin } from "antd";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import axiosInstance from "../common/api";
import { filterOption, requiredField } from "../common/common";
import DebounceSelect from "../common/DebounceSelect";

export default function () {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [form] = Form.useForm();
    const [paychecks, setPaychecks] = useState([]);
    const [isFineLinked, setIsFineLinked] = useState(false);
    const { id } = useParams();
    const employeeWatch = Form.useWatch("employee", form);

    useEffect(() => {
        setLoading(true);
        axiosInstance
            .get(`charge/${id}`)
            .then(({ data }) => {
                setIsFineLinked(!!data.fine);
                form.setFieldsValue({
                    ...data,
                    employee: {
                        label: data.employee.fullName,
                        value: data.employee.id,
                        key: data.employee.id,
                    },
                    chargedPaycheck: data.chargedPaycheck?.id,
                });
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        if (employeeWatch?.value) {
            axiosInstance
                .get("paycheck", {
                    params: {
                        page: 0,
                        pageSize: 10000,
                        employee: employeeWatch.value,
                    },
                })
                .then(({ data }) => setPaychecks(data.data));
        } else {
            setPaychecks([]);
        }
    }, [employeeWatch]);

    const onFinish = (formData) => {
        setLoading(true);
        const transf = {
            ...formData,
            employee: formData.employee.value,
        };
        axiosInstance
            .put(`charge/${id}`, transf)
            .then(() => navigate(-1))
            .finally(() => setLoading(false));
    };

    return (
        <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item name="description" label="Descrizione" rules={[requiredField]}>
                    <Input disabled={isFineLinked} />
                </Form.Item>
                <Form.Item
                    name="date"
                    label="Data"
                    rules={[requiredField]}
                    getValueProps={(value) => ({ value: value && dayjs(value) })}
                    normalize={(value) => value && value.format("YYYY-MM-DD")}
                >
                    <DatePicker format="DD/MM/YYYY" disabled={isFineLinked} />
                </Form.Item>
                <Form.Item name="employee" label="Dipendente" rules={[requiredField]}>
                    <DebounceSelect
                        disabled
                        onChange={() => form.setFieldValue("chargedPaycheck", null)}
                        fetchOptions={(query) =>
                            axiosInstance
                                .get("employeeCompact", {
                                    params: {
                                        startDate: "1900-01-01",
                                        endDate: "9999-01-01",
                                        query,
                                    },
                                })
                                .then(({ data }) =>
                                    data.map((x) => ({
                                        label: x.fullName,
                                        value: x.id,
                                    })),
                                )
                        }
                    />
                </Form.Item>
                <Form.Item label="Importo" name="amount" rules={[requiredField]}>
                    <InputNumber
                        decimalSeparator=","
                        precision={2}
                        controls={false}
                        disabled={isFineLinked}
                    />
                </Form.Item>
                <Form.Item name="chargedPaycheck" label="Cedolino addebitato">
                    <Select
                        filterOption={filterOption}
                        showSearch
                        allowClear
                        options={paychecks
                            .sort((a, b) => b.id - a.id)
                            .map((x) => ({
                                label: x.period + " " + x.year,
                                value: x.id,
                            }))}
                    />
                </Form.Item>
                <Form.Item style={{ textAlign: "end" }}>
                    <Button loading={loading} htmlType="submit" type="primary">
                        Conferma
                    </Button>
                </Form.Item>
            </Form>
        </Spin>
    );
}
